
import React from 'react'
import {withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import WarningIcon from '@material-ui/icons/Warning'


const styles = theme => ({
  gridContainer: {
    padding: theme.spacing.unit,
    paddingBottom: theme.spacing.unit * 2
  },
  warning: {
    backgroundColor: theme.palette.warning.light,
    border: `1px solid ${theme.palette.warning.dark}`,
    display: 'flex',
    margin: '0 auto',
    padding: theme.spacing.unit,
    width: '95%'
  },
  warningIcon: {color: theme.palette.warning.primary},
  warningText: {fontSize: '1rem', paddingLeft: 15, width: '100%'}
})


const SessionCompleteNotice = ({classes, children}) => (
  <Grid container className={classes.gridContainer}>
    <Grid item xs={12}>
      <Paper className={classes.warning} elevation={0}>
        <WarningIcon className={classes.warningIcon} />
        <Typography className={classes.warningText} variant="subheading">
          {children}
        </Typography>
      </Paper>
    </Grid>
  </Grid>
)

export default withStyles(styles)(SessionCompleteNotice)


// WEBPACK FOOTER //
// ./src/components/counseling-session/SessionCompleteNotice.js